import { FundType } from '@fund-base/types/types/types.types';

export function resolveAiFundTypes(aiFundTypes: string[], availableTypes: FundType[]): { id: string; text: string }[] {
  const selected: FundType[] = [];
  const indexById = new Map(availableTypes.map(type => [String(type.id), type]));

  for (const fundType of aiFundTypes) {
    const canonical = mapToCanonicalFundType(fundType);
    if (!canonical) continue;

    let matched: FundType | undefined;
    if (canonical === 'Foundations') matched = indexById.get('1');
    if (canonical === 'Businesses') matched = indexById.get('2');
    if (canonical === 'Government Grants') matched = indexById.get('3');
    if (canonical === 'Endowment') matched = indexById.get('4');

    if (!matched) {
      matched = availableTypes.find(type => mapToCanonicalFundType(type.text) === canonical);
    }

    if (matched && !selected.some(item => String(item.id) === String(matched?.id))) {
      selected.push(matched);
    }
  }

  return selected.map(type => ({ id: String(type.id), text: type.text }));
}

export function mapToCanonicalFundType(value: string): string | null {
  const normalized = normalizeFundTypeKeyword(value ?? '');
  if (!normalized) return null;

  const foundations = new Set(['foundations', 'foundation', 'fund', 'found', 'קרנות', 'קרן', 'הקרן', 'מקרנות']);
  const businesses = new Set([
    'businesses',
    'business',
    'corporate',
    'corporations',
    'corporation',
    'companies',
    'company',
    'csr',
    'esg',
    'עסקים',
    'עסק',
    'חברות',
    'חברה',
    'תאגידים',
    'תאגידיים',
    'תאגיד',
    'אחריות תאגידית',
    'קיימות תאגידית',
  ]);
  const governmentGrants = new Set([
    'government',
    'government grants',
    'government grant',
    'rfp',
    'rfps',
    'request for proposal',
    'request for proposals',
    'מענקים ממשלתיים',
    'מענק ממשלתי',
    'קול קורא',
    'קולות קוראים',
    'תמיכה',
    'תמיכה ממשלתית',
  ]);
  const endowment = new Set([
    'endowment',
    'endowments',
    'estates',
    'bequests',
    'הקדש',
    'הקדשים',
    'הקדשות',
    'עזבונות',
    'עיזבונות',
    'צוואות',
  ]);

  if (foundations.has(normalized)) return 'Foundations';
  if (businesses.has(normalized)) return 'Businesses';
  if (governmentGrants.has(normalized)) return 'Government Grants';
  if (endowment.has(normalized)) return 'Endowment';

  return null;
}

export function normalizeFundTypeKeyword(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/["'`.,:;!?()[\]{}]/g, '')
    .replace(/\s+/g, ' ');
}
